<script setup lang="ts">
import XhSidebar from '../components/home/XhSidebar.vue'
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'
const router = useRouter()
const route = useRoute()
const root = router.currentRoute.value.query.root as string
const routerKey = computed(() => {
  return route.fullPath
})
</script>

<template>
  <div class="xh-home">
    <div class="xh-sidebar">
      <XhSidebar></XhSidebar>
    </div>
    <div class="xh-main">
      <router-view :key="routerKey" />
    </div>
  </div>
</template>

<style scoped>
.xh-home {
  width: 100%;
  height: 100%;
  display: flex;
}

.xh-sidebar {
  height: 100%;
  width: 98px;
  position: relative;
  z-index: 100;
}

.xh-main {
  flex: 1;
  /* width: calc(100% - 142px);
  background: #f4f5fa; */
}
</style>
